import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import AuthLayout from "./AuthLayout";

function Login({ setToken }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const registerSuccessMessage = localStorage.getItem(
      "registerSuccessMessage"
    );
    if (registerSuccessMessage) {
      toast.success(registerSuccessMessage);
      setTimeout(() => {
        localStorage.removeItem("registerSuccessMessage");
      }, 2000);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}dlogin`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status === "success") {
        sessionStorage.setItem("token", "loggedIn");
        // Set the token in App.js via setToken
        setToken("loggedIn");
        navigate("/"); // Redirect to the dashboard or home
      } else {
        toast.error(response.data.message || "Invalid credentials");
      }
    } catch (error) {
      console.error("Login Error:", error);
      toast.error(error.response?.data?.detail || "We couldn’t sign you in. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={4000} />
      <AuthLayout title="Welcome back" subtitle="Log in to explore the latest India Budget data with Aivio.">
        <form onSubmit={handleLogin} className="auth-form">
          <div className="mb-3">
            <label className="form-label" htmlFor="login-email">Work email</label>
            <input
              id="login-email"
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              autoComplete="email"
              required
              name="email"
            />
          </div>
          <div className="mb-2">
            <div className="auth-label-row">
              <label className="form-label" htmlFor="login-password">Password</label>
              <Link to="/forgot-password">Forgot password?</Link>
            </div>
            <input
              id="login-password"
              type="password"
              name="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button type="submit" className="btn auth-submit" disabled={loading}>
            {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Logging in…</> : <>Log in <span aria-hidden="true">→</span></>}
          </button>
          <p className="auth-switch">
            New to Aivio? <Link to="/register">Create a free account</Link>
          </p>
        </form>
      </AuthLayout>
    </>
  );
}

export default Login;
